$(document).ready(function() {
    $('.test').on('click', () => {
        alert('Click me!')
    })
})